import React, { Component } from "react";

class Loading extends Component {
  render() {
    return (
      <div className="loading">
        <p>Loading...</p>
      </div>
    );
  }
}

export default Loading;
